import React, { useState, useEffect } from "react";
import FooterLogo from "../../Assets/CustomerCapitalLogo.png";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../Components/Loader/Loader";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import AutoSizeTextCanvas from "../../Components/TexttoCanvas";

const Footer = () => {
  const rootStyles = getComputedStyle(document.documentElement);
  const footerTextColor = rootStyles
    .getPropertyValue("--footer-text-color")
    .trim();
  const footerBgColor = rootStyles.getPropertyValue("--footer-bg-color").trim();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const staticPointsData = useSelector(
    (state) => state.staticPointsReducer?.isLoading
  );
  const translation = getTranslationData();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const clientConfig = useSelector((state) => state.clientConfigurationReducer);
  const clientConfigData = clientConfig?.clientConfigurationData?.[0];
  const location = useLocation();

  if (
    location.pathname.endsWith("/otp") ||
    (isMobile && location.pathname.endsWith("/productlist"))
  ) {
    return null;
  }

  return (
    <>
      <ScrollToTop />
      {staticPointsData || clientConfig?.isLoading ? (
        <Loader />
      ) : (
        <footer className="footer">
          <div className="top-footer new-ft pd-ft pad-ft">
            <div className="container-fluid">
              <div className="row">
                <div
                  className={`col-md-6 col-lg-3 col-xl-3 footer-head ${isMobile ? "cols-6" : "col-6"
                    }`}
                >
                  <div className="footlist">
                    <div className="footsocial">
                      <div className="foothead">Powered By</div>
                      <img className="kok" src={FooterLogo} alt="img" />
                    </div>
                  </div>
                </div>
                <div className="list">
                  <div
                    className={`${isMobile ? "" : "col-12 col-md-6 col-lg-3 col-xl-3"
                      }`}
                  >
                    <div className="footlist padd-left1">
                      <ul className="footul">
                        {clientConfigData?.phoneNumber &&
                          <li>
                            <div className="d-flex align-item-center footerheadText">
                              <i
                                className={`las la-phone-alt`}
                                style={{ transform: "rotate(-85deg)" }}
                              ></i>
                              <AutoSizeTextCanvas
                                text={clientConfigData?.phoneNumber}
                                textColor={footerTextColor}
                                bgColor={footerBgColor}
                              />
                            </div>
                            {/* <Link
                            to="tel:+91 9999999999"
                            className="footerheadText"
                          >
                            <i
                              className="las la-phone-alt"
                              style={{ transform: "rotate(-85deg)" }}
                              // style="transform: rotate(-85deg);"
                            ></i>
                            &nbsp;{`+91 ${clientConfigData?.phoneNumber}`}
                          </Link> */}
                          </li>
                        }
                        {clientConfigData?.email &&
                          <li>
                            <div className="d-flex footerheadText">

                              <i className={`las la-envelope `}></i>{" "}
                              <a href={`mailto:${clientConfigData?.email}`}>
                                <AutoSizeTextCanvas
                                  text={clientConfigData?.email}
                                  textColor={footerTextColor}
                                  bgColor={footerBgColor}
                                />
                              </a>
                            </div>
                            {/* <Link
                            to="mailto:support@cc.giftstacc.com"
                            className="fnt-13 footerheadText footer-email-txt"
                          >
                            <i className="las la-envelope"></i>
                            <AutoSizeTextCanvas text={clientConfigData?.email} />
                            &nbsp;{clientConfigData?.email}
                          </Link> */}
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                  {isMobile ? (
                    <>
                      {" "}
                      <div
                        className={`${isMobile ? "" : "col-12 col-md-6 col-lg-3 col-xl-3"
                          }`}
                      >
                        <div className="footlist">
                          <ul className="footul">
                            <li>
                              <Link to="/static/About-Us">
                                {translation?.aboutGiftstacc}{" "}
                              </Link>
                            </li>
                            <li>
                              <Link to="/static/Terms-and-Conditions">
                                {translation?.termsAndConditions}
                              </Link>
                            </li>
                            <li>
                              <Link to="/static/Privacy-Policy">
                                {translation?.privacyPolicy}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        className={`${isMobile ? "" : "col-12 col-md-6 col-lg-3 col-xl-3"
                          }`}
                      >
                        <div className="footlist padd-left2">
                          <ul className="footul">
                            <li>
                              <Link to="/static/FAQ">{translation?.faq}</Link>
                            </li>
                            <li>
                              <Link to="/contact-us">
                                {translation?.contactUs}
                              </Link>
                            </li>
                            <li>
                              <Link to="/static/Cancellation-and-Returns-Policy">
                                {translation?.cancellationAndReturn}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {" "}
                      <div
                        className={`${isMobile ? "" : "col-12 col-md-6 col-lg-3 col-xl-3"
                          }`}
                      >
                        <div className="footlist">
                          <ul className="footul">
                            <li>
                              <Link
                                to="/contact-us"
                                className="text-capitalize"
                              >
                                {" "}
                                {translation?.contactUs}{" "}
                              </Link>
                            </li>
                            <li>
                              <Link to="/static/About-Us">
                                {translation?.aboutUs}
                              </Link>
                            </li>
                            <li>
                              <Link to="/static/Cancellation-and-Returns-Policy">
                                {translation?.refundPolicy}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        className={`${isMobile ? "" : "col-12 col-md-6 col-lg-3 col-xl-3"
                          }`}
                      >
                        <div className="footlist">
                          <ul className="footul">
                            <li>
                              <Link to="/static/Terms-and-Conditions">
                                {translation?.termsAndConditions}
                              </Link>
                            </li>
                            <li>
                              <Link to="/static/Privacy-Policy">
                                {translation?.privacyPolicy}
                              </Link>
                            </li>
                            <li>
                              <Link to="/static/FAQ">{translation?.faq}</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* {!isMobile ? (
                  <div
                    className={`${
                      isMobile ? "" : "col-12 col-md-6 col-lg-3 col-xl-3"
                    }`}
                  >
                    <div className="footlist">
                      <h4>{login ? "My Account" : ""}</h4>
                      <ul className="footul">
                        {login ? (
                          <>
                            <li>
                              <Link to="/orders">My Orders</Link>
                            </li>
                            <li>
                              <Link to="/myprofile">My Profile</Link>
                            </li>
                          </>
                        ) : (
                          ""
                        )}
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )} */}
              </div>
            </div>
          </div>
          <div className="footer-container-2 py-3 pd-f">
            <div className="row justify-content-center">
              <div className="col-xl-12 col-md-12 col-12">
                <div className="copytextbox text-center">
                  <span className="footer-span">
                    © {translation?.footerCopyright}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
